var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 48,
    viewBox: "0 0 42 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4505 8.37811C25.1706 5.99249 26.2843 3.7605 27.74 1.78545C28.1241 1.2787 28.6021 0.860296 29.1445 0.55592C29.687 0.251544 30.2826 0.0676154 30.8947 0.0154196C31.5068 -0.0367762 32.1225 0.0438667 32.7041 0.252392C33.2856 0.460917 33.8208 0.792926 34.2767 1.22805C34.9295 1.83688 35.5075 2.52997 35.9971 3.29106C36.3116 3.78933 36.5218 4.35283 36.6138 4.94392C36.7058 5.535 36.6775 6.14004 36.5307 6.71861C36.3839 7.29718 36.122 7.83595 35.7626 8.29891C35.4031 8.76187 34.9543 9.13835 34.4463 9.40321C31.7383 10.6846 27.7824 12.2222 24.4445 12.2222L24.4505 8.37811Z",
    fill: "#B4BBBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1111 8.74692C16.3915 6.6045 15.2785 4.60005 13.8237 2.82634C13.4398 2.37155 12.9623 1.99598 12.4204 1.72259C11.8785 1.4492 11.2836 1.28375 10.6721 1.23635C10.0607 1.18896 9.44545 1.26062 8.86411 1.44695C8.28277 1.63327 7.74755 1.93036 7.29117 2.32002C6.64011 2.87024 6.06265 3.4944 5.57176 4.17847C5.25306 4.62628 5.03914 5.13386 4.94443 5.66694C4.84972 6.20002 4.87643 6.74621 5.02275 7.26865C5.16908 7.79108 5.43162 8.27761 5.79265 8.69541C6.15368 9.1132 6.60481 9.45254 7.11559 9.69053C9.82183 10.8413 13.7753 12.2222 17.1111 12.2222V8.74692Z",
    fill: "#B4BBBF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.44446 23.2402H39.1111V46.0517C39.1087 46.2661 39.0626 46.478 38.9753 46.6752C38.8881 46.8724 38.7616 47.0511 38.6029 47.201C38.4442 47.351 38.2564 47.4693 38.0504 47.5491C37.8444 47.629 37.6241 47.6689 37.4021 47.6665H4.12864C3.6814 47.6649 3.25303 47.4922 2.93736 47.1862C2.6217 46.8801 2.44445 46.4657 2.44446 46.0337V23.2222V23.2402Z",
    fill: "url(#paint0_linear_190_161)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3791 11H1.17651C0.526741 11 0 11.5495 0 12.2274V21.9948C0 22.6727 0.526741 23.2222 1.17651 23.2222H40.3791C41.0288 23.2222 41.5556 22.6727 41.5556 21.9948V12.2274C41.5556 11.5495 41.0288 11 40.3791 11Z",
    fill: "url(#paint1_linear_190_161)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4445 23.2222H15.8889V47.6666H24.4445V23.2222Z",
    fill: "#E8E8E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4445 11H15.8889V23.2222H24.4445V11Z",
    fill: "#B4BBBF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M39.1111 23.2222H2.44446V28.1111H39.1111V23.2222Z",
    fill: "#68253D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_190_161",
    x1: 20.7778,
    y1: 23.2222,
    x2: 20.7778,
    y2: 47.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE531F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_190_161",
    x1: 20.7778,
    y1: 11,
    x2: 20.7778,
    y2: 23.2222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE531F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7171"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftBox);
export default __webpack_public_path__ + "static/media/giftBox.1b2792ace5c0b2c7d05072c579db9782.svg";
export { ForwardRef as ReactComponent };